<template>
    <q-layout view="hHh lpR fFf">
        <q-header class="bg-white pd_left_40 pd_right_40">
            <q-toolbar>
                <p class="display_flex color_gray_900">
                    <q-icon name="img:/assets/images/icon/ico_back.svg" @click="onBack" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                    <span class="q-px-sm b1 medium line_height_45 header_lesson">진단평가</span>
                </p>
                <p class="home__img">
                    <q-icon name="img:/assets/images/icon/ico_home.svg" @click="onHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                </p>
            </q-toolbar>
        </q-header>
        <q-page-container>
            <q-page>
                <div class="color_gray_900 page__content">
                    <div class="page__inner">
                        <div class="display_flex page__title">
                            <!-- <p class="page__img">
                                <img src="@/assets/images/icon/kread_logo_new.svg" />
                            </p> -->
                            <p class="mg_left_8 bold">진단평가</p>
                        </div>
                        <div class="display_flex eval__content">
                            <div class="display_flex panel">
                                <p class="panel__img">
                                    <img src="@/assets/images/icon/ico_total.png" />
                                </p>
                                <p class="h3 bold txt_center">36문항<span class="display_block b3 medium">(지문당 3문항)</span></p>
                            </div>
                            <div class="display_flex panel">
                                <p class="panel__img">
                                    <img src="@/assets/images/icon/ico_clock_green.png" />
                                </p>
                                <p class="h3 bold txt_center">60분<span class="display_block b3 medium">(권장 평가 시간)</span></p>
                            </div>
                        </div>
                        <!-- <div style="width: 100%; margin: 20px 0px"> -->
                        <ul class="panel page__txt">
                            <li class="b2 line_height_45">진단평가는 총 36문항으로, 모든 문항은 오지선다형입니다.</li>
                            <li class="b2 line_height_45">문제 풀이 후에는 이전 문제로 돌아갈 수 없으니 신중하게 문제를 풀어 주세요.</li>
                            <li class="b2 line_height_45">평가가 시작되면 중간에 종료할 수 없으므로, 끝까지 문제를 풀어 주시기 바랍니다.</li>
                            <li class="b2 line_height_45">전체 문항에 대한 풀이가 완료되면 채점 결과를 확인할 수 있습니다.</li>

                            <!-- <li class="b2 line_height_45">평가가 시작되면 중간에 종료할 수 없습니다.</li>
                            <li class="b2 line_height_45">전체 문항에 대한 답안 체크가 모두 완료되었을 경우 최종 제출이 가능해요.</li>
                            <li class="b2 line_height_45">다음 페이지로 이동하려면 이전 문제로 돌아갈 수 없으니 신중하게 문제를 풀어 주세요.</li> -->
                        </ul>
                        <!-- <p class="b2 line_height_45 panel page__txt">
                            · 평가가 시작되면 중간에 종료할 수 없습니다.<br />
                            · 전체 문항에 대한 답안 체크가 모두 완료되었을 경우 최종 제출이 가능해요.<br />
                            · 다음 페이지로 이동하려면 이전 문제로 돌아갈 수 없으니 신중하게 문제를 풀어 주세요.<br />
                        </p> -->
                        <!-- </div> -->
                        <!-- <div style="margin: 20px 0px;">
                            <div
                                style="width: 100%;border: 1px solid #000000;display: inline-grid; padding: 20px;font-weight: 500;background-color: #F7F7F7; font-size: 2.75vmin;">
                                평가 시작버튼을 누르면 모의평가가 시작됩니다.
                            </div>
                            </div> -->
                        <p class="mg_top_32">
                            <CusButton :type="200" :label="`평가 시작`" @onReturn="onClick" />
                            <!-- <q-btn :onClick="onClick" color="primary" label="평가 시작" /> -->
                        </p>
                    </div>
                </div>
            </q-page>
        </q-page-container>
    </q-layout>
</template>

<script setup>
import { defineEmits, ref, onMounted, onUnmounted, watch, computed, toRaw, defineProps } from 'vue';
import customHeader from '@/components/layouts/header/header.vue';
import CusButton from '@/components/widget/CusButton.vue';
import { useQuasar } from 'quasar';
import { DialogStore } from '@/store/modules/dialog';
import { GlobalStore } from '@/store';
import { useRouter } from 'vue-router';

const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const emit = defineEmits(['on-start']);
const props = defineProps({
    isLoading: {
        default: false,
    },
});

const onClick = () => {
    // console.log('onClick defineEmits ');
    emit('on-start');
};

const onBack = () => {
    emit('update:isLoading', true); // 'update:isLoading' 이벤트 발생
    router.go(-1);
};

const onCallback = (val) => {
    // console.log('gStore.is_member_eval:', gStore.is_member_eval);
    // router.go(router.currentRoute);
    if (val) {
        if (gStore.is_member_eval) router.push('/learninghome');
        else router.go(router.currentRoute);
    }
};
const onHome = () => {
    dStore.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: onCallback,
    });
};
</script>

<style scoped lang="scss">
p {
    margin-bottom: 0;
    line-height: inherit;
}

img {
    width: 100%;
}

::v-deep {
    .q-toolbar {
        justify-content: space-between;
        align-items: center;
        min-height: inherit;
        margin: 1.75vmin 0;
        padding: 0;

        .display_flex {
            align-items: center;
        }

        .q-icon {
            width: 2.4vw;
            height: 2.4vw;
            font-size: 1.4vw; //28px
            font-weight: 700;
        }

        .home__img {
            .q-icon {
                display: inline-block;
                width: 2.1vw;
                height: 2.1vw;
                padding: 0.29vmin 0.37vmin;
                box-sizing: border-box;
            }
        }
    }
}

.page {
    &__content {
        position: absolute;
        top: 45%;
        left: 0;
        width: 100%;
        @include transform(translateY(-50%));

        button {
            width: 100%;
            padding: 2.75vmin 2.83vmin;
            @include border-radius(1.33vmin);
            font-size: 1.2vw;
            font-weight: 700;
            line-height: 1.6vw;
        }
    }

    &__inner {
        width: 60%;
        max-width: 1178px;
        margin: 0 auto;
    }

    &__title {
        align-items: center;
        justify-content: center;
        .bold {
            font-size: 2.76vw;
            line-height: 3.35vw;
        }
    }

    &__img {
        width: 47%;
        max-width: 188px;
    }

    &__txt {
        margin-top: 2.17vmin;
        padding: 4.08vmin 7.5vmin;

        li {
            margin-left: 1.25vmin;
            list-style: disc;
        }
    }
}

.eval__content {
    justify-content: space-between;
    margin-top: 6.83vmin;
    box-sizing: border-box;
    .panel {
        align-items: center;
        width: calc((100% - 1.67vmin) / 2);
    }

    .h3 {
        width: 100%;
    }
}

.panel {
    overflow: hidden;
    border: 1px solid $color_gray_500;
    @include border-radius(1.33vmin);

    &__img {
        flex: 0 0 auto;
        width: 28%;
        max-width: 156px;
        max-height: 168px;
        padding: 2vmin 1.58vmin;
        border-right: 1px solid $color_gray_500;
        background: $color_gray_200;
    }
}
</style>
